import React from 'react';
import PropTypes from 'prop-types';
import './WorkflowTask.scss'
import WorkflowTaskModal from './WorkflowTaskModal';

const WorkflowTaskResetModal = (props) => {
    return (
        <WorkflowTaskModal isOpen={props.isOpen} titleKey={props.titleKey} contentKeys={props.contentKeys}
            primaryButtonKey={props.resetButtonKey}
            onConfirm={props.onReset} 
            onCancel={props.onCancel} />
    );
}

WorkflowTaskResetModal.whyDidYouRender = false;

WorkflowTaskResetModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    onCancel: PropTypes.func,
    onReset: PropTypes.func.isRequired,
    titleKey: PropTypes.string.isRequired,
    contentKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    resetButtonKey: PropTypes.string.isRequired
}

export default WorkflowTaskResetModal